export default __webpack_public_path__ + "static/visius-04b14e9bca5af1fba380372202af2c56.jpg";